import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { MessageModel } from './models/smsMessage.model';
import { HttpHeaders, HttpResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { UtilityService, HttpClientService, AdobeAnalyticsService } from './../../../lib/ng2-sapmp/src/providers';
import { GridOptionsModel, ColumnDefinitionsModel, PaginationsModel, GridSortService } from './../../../lib/ng2-sapmp/src/ui-components';
import { ENV, ANALYTICS_CONSTANTS } from 'config';


declare var ENV_VAR: any;

@Injectable()
export class SendSMSService {
    private pageJson: BehaviorSubject<any> = new BehaviorSubject<any>('');
    private pageError: BehaviorSubject<any> = new BehaviorSubject<any>('');
    public obvPageJson: Observable<any> = this.pageJson.asObservable(); // convert to Observable for subscribing
    public obvPageError: Observable<any> = this.pageError.asObservable();

    constructor(private utilityService: UtilityService,
        private httpClientService: HttpClientService,
        private gridService: GridSortService,
        private adobeAnalyticsService: AdobeAnalyticsService) {
    }

    setPageJson(json) {
        this.pageJson.next(json);
    }

    getPageJson(): Observable<any> {
        return this.obvPageJson;
    }

    setPageError(err) {
        this.pageError.next(err);
    }

    getPageError(): Observable<any> {
        return this.obvPageError;
    }

    setMessageModel(message: MessageModel) {
        sessionStorage.setItem('savedMessage', JSON.stringify(message));
    }

    getMessageModel() {
        return JSON.parse(sessionStorage.getItem('savedMessage')) || new MessageModel();
    }

    removeMessageModel() {
        sessionStorage.removeItem('savedMessage');
    }

    createGridOptions(list, columns, accountType, step) {
        const sortBy = accountType === 'allFans' ? 'fanId' : 'ctnNumber';
        const filterSortEnabled = step === 2 ? true : false;
        this.gridService.getSortedData(list, sortBy, 'Asc');
        const gridOption = new GridOptionsModel();

        const pages: PaginationsModel = {
            recordsPerPage: 20,
            currentPage: 1,
            totalRecords: list.length,
            isServerSide: false
        };

        gridOption.showGrid = accountType === 'allCTN' && step === 2 ? false : true;
        gridOption.enableFiltering = ((list.length > 20 || accountType === 'allCTN') && filterSortEnabled) ? true : false;
        gridOption.columnDefinitions = JSON.parse(JSON.stringify(columns));
        gridOption.enableSorting = filterSortEnabled;
        gridOption.gridData = list;
        gridOption.Paginations = pages;
        gridOption.showPaginationIndex = filterSortEnabled;
        gridOption.searchPlaceHolder = accountType === 'allFans' ? 'Enter full foundation account number' : 'Enter 10-digit number';
        gridOption.searchDescriptions = '';
        gridOption.enableBackLink = filterSortEnabled ? true : false;
        gridOption.backLinkText = accountType === 'allFans' ? 'View all accounts' : 'View all numbers';
        gridOption.emptyMessage = 'No results';
        gridOption.multiSelect = true;
        gridOption.disableGrid = false;
        gridOption.disableRow = false;
        gridOption.disableRowCondition = { field: '', value: '' };
        if (accountType === 'allFans' ? false : true) {
            gridOption.callbacks = {ctnFormatterTemplate: this.ctnFormatterTemplate};
        } else {
            gridOption.callbacks = null;
        }
        gridOption.ctnMask = accountType === 'allFans' ? false : true;
        gridOption.maxLength = accountType !== 'allFans' ? 12 : undefined;
        gridOption.searchType = accountType === 'allFans' ? 'number' : undefined;
        gridOption.ariaLabel = 'Select all foundation account numbers';
        return gridOption;
    }

    ctnFormatterTemplate(element, row, field, currentElem, type) {
        const formatctnNumber = row.ctnNumber.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1.$2.$3');
        return `<p>${formatctnNumber}</p>`;
    }

    filterSelected(list) {
        return list.filter(item => {
            if (item.selected) {
                return item;
            }
        });
    }

    toggleSelect(list) {
        return list.filter(item => {
            item.selected = !item.selected;
            return item;
        });
    }

    get_headers() {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
        return headers;
      }

    fetchJSON(dataurl) {
        return this.httpClientService.get(dataurl, this.get_headers())
          .pipe(
       map((res: HttpResponse<any>) => {
            if (sessionStorage.getItem('sapmp_jwtToken') != null) {
              // refreshes token for logged in scenario upon page load
              this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
            }
            return res.body;
          })
          ,catchError( this.handleError ));
      }

    getFANList(companyid) {
        let fanUrl;
        if (this.utilityService.getEnvConfig().useMock) {
            // Added for demo purpose
            const mockUrl = parseInt(sessionStorage.getItem('fanLength')) > 15 ? 'sendSMSFanList' : 'abridgedList';
            fanUrl = this.utilityService.getEnvConfig()[mockUrl];
        } else {
            fanUrl = this.utilityService.getEnvConfig().getFANList;
        }
        return this.httpClientService.get(fanUrl, this.getHeaders())
            .pipe(
       map((res: HttpResponse<any>) => {
                if (sessionStorage.getItem('sapmp_jwtToken') != null) {
                    // refreshes token for logged in scenario upon page load
                    this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
                }
                return res.body;
            }));
    }

    getCtnList(fanId) {
        let url;
        // let payload = {
        //     "fan": fanId,
        //   };
        if (this.utilityService.getEnvConfig().useMock) {
            url = this.utilityService.getEnvConfig().sendSmsMockJson;
        } else {
            
            url = this.utilityService.getEnvConfig().getProfileStatusUrl + '?fan=' + fanId;
            // url = this.utilityService.getEnvConfig().getProfileStatusUrl;
        }
        return this.httpClientService.get(url, this.getHeaders())
            .pipe(
       map((res: HttpResponse<any>) => {
                if (sessionStorage.getItem('sapmp_jwtToken') != null) {
                    // refreshes token for logged in scenario upon page load
                    this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
                }
                return res.body;
            }));
    }

    getHeaders() {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
        return headers;
    }

    postSMS(message, ctnDetails?) {
        if (this.utilityService.getEnvConfig().useMock) {
            return Observable.create(function (observer) {
                observer.next(1);
                observer.complete();
            });
        } else {
            const url = this.utilityService.getEnvConfig().sendSMSUrl;
            let headers = new HttpHeaders();
            headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
            if (ctnDetails !== undefined) {
                headers = headers.append('ban', ctnDetails.ban);
                headers = headers.append('imei', ctnDetails.deviceInfo.imei);
            }
            return this.httpClientService.post(url, message, headers)
                .pipe(
       map((res: HttpResponse<any>) => {
                    if (sessionStorage.getItem('sapmp_jwtToken') != null) {
                        // refreshes token for logged in scenario upon page load
                        this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
                    }
                    return res.body;
                }));
        }
    }

    handleError(error) {
        return throwError(error);
      }

    extractIds(list, field) {
        const idArray = [];
        list.filter(item => {
            if (item.selected) {
                idArray.push(item[field]);
            }
        });
        return idArray;
    }

    computeLength(text: string) {
        return text.replace(/(\r\n|\r|\n)/g, '').length;
    }
    createPageLoadProperties(url, section2) {
        const dataLayer = {};
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FRIENDLY_PAGE_NAME] = ANALYTICS_CONSTANTS['FRIENDLY_NAME_SMS_' + url];
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_FLOW_CODE] = ANALYTICS_CONSTANTS.FLOW_CODE_SMS;
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR] = ANALYTICS_CONSTANTS.GLOBAL_USER_REPRESENTATIVE_IPADDR;
        // dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_LANGUAGE] = 'EN';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_PAGE_FUNCTION] = 'Service';
        dataLayer[ANALYTICS_CONSTANTS.GLOBAL_PAGE_SITE_SECTION1] = section2;
        if (sessionStorage.getItem('sapmp_jwtToken') != null) {
            dataLayer[ANALYTICS_CONSTANTS.GLOBAL_USER_LOGIN_SOURCE] = 'shoplogin';

        }
        this.adobeAnalyticsService.tag('page', dataLayer, 'Page_Load', 'pageLoad');
    }

    getGroupDevicesData(fan: any, sessionId: any){
        let url = this.utilityService.getEnvConfig().getGroupDevices+'?fan='+ fan + '&sessionId='+sessionId;
        return this.httpClientService.authorizedGet(url)
          .pipe(
            map((res: HttpResponse<any>) => {
              if (sessionStorage.getItem('sapmp_jwtToken') != null) {
                // refreshes token for logged in scenario upon page load
                this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
              }
            
            return res.body;
            }), 
            catchError(this.handleError));
    }
}
